import DescriptionField from './DescriptionField/DescriptionField';

const DescriptionFieldDirective = reactDirective => {
  return reactDirective(DescriptionField, undefined, { restrict: 'E' }, {});
};

DescriptionFieldDirective.$inject = ['reactDirective'];

export default DescriptionFieldDirective;
